import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import '../../App.css';

const AdminDashboard = () => {
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/admin/login');
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#0f172a', padding: '2rem' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '3rem',
          padding: '1.5rem',
          background: 'rgba(30, 41, 59, 0.8)',
          borderRadius: '1rem',
          border: '1px solid rgba(148, 163, 184, 0.2)'
        }}>
          <div>
            <h1 style={{ color: '#f1f5f9', marginBottom: '0.5rem' }}>
              🎛️ Panel Administrativo
            </h1>
            <p style={{ color: '#94a3b8', margin: 0 }}>
              Bienvenido, {currentUser?.email}
            </p>
          </div>
          <button
            onClick={handleLogout}
            style={{
              padding: '0.75rem 1.5rem',
              borderRadius: '0.5rem',
              border: 'none',
              background: 'rgba(239, 68, 68, 0.2)',
              color: '#fca5a5',
              cursor: 'pointer',
              fontWeight: 'bold'
            }}
          >
            Cerrar Sesión
          </button>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '2rem'
        }}>
          <Link to="/admin/blog" style={{ textDecoration: 'none' }}>
            <div style={{
              padding: '2rem',
              background: 'rgba(30, 41, 59, 0.8)',
              borderRadius: '1rem',
              border: '1px solid rgba(148, 163, 184, 0.2)',
              cursor: 'pointer',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-5px)';
              e.currentTarget.style.borderColor = 'rgba(59, 130, 246, 0.5)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.borderColor = 'rgba(148, 163, 184, 0.2)';
            }}>
              <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>📝</div>
              <h2 style={{ color: '#f1f5f9', marginBottom: '0.5rem' }}>
                Gestión de Blog
              </h2>
              <p style={{ color: '#94a3b8', margin: 0 }}>
                Crear, editar y eliminar posts del blog
              </p>
            </div>
          </Link>

          <Link to="/admin/activate-subscription" style={{ textDecoration: 'none' }}>
            <div style={{
              padding: '2rem',
              background: 'rgba(30, 41, 59, 0.8)',
              borderRadius: '1rem',
              border: '1px solid rgba(148, 163, 184, 0.2)',
              cursor: 'pointer',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-5px)';
              e.currentTarget.style.borderColor = 'rgba(16, 185, 129, 0.5)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.borderColor = 'rgba(148, 163, 184, 0.2)';
            }}>
              <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🔑</div>
              <h2 style={{ color: '#f1f5f9', marginBottom: '0.5rem' }}>
                Activar Suscripciones
              </h2>
              <p style={{ color: '#94a3b8', margin: 0 }}>
                Activar manualmente suscripciones de usuarios
              </p>
            </div>
          </Link>

          <div style={{
            padding: '2rem',
            background: 'rgba(30, 41, 59, 0.5)',
            borderRadius: '1rem',
            border: '1px solid rgba(148, 163, 184, 0.2)',
            opacity: 0.6
          }}>
            <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>📄</div>
            <h2 style={{ color: '#f1f5f9', marginBottom: '0.5rem' }}>
              Gestión de Páginas
            </h2>
            <p style={{ color: '#94a3b8', margin: 0 }}>
              Próximamente...
            </p>
          </div>

          <Link to="/" style={{ textDecoration: 'none' }}>
            <div style={{
              padding: '2rem',
              background: 'rgba(30, 41, 59, 0.8)',
              borderRadius: '1rem',
              border: '1px solid rgba(148, 163, 184, 0.2)',
              cursor: 'pointer',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-5px)';
              e.currentTarget.style.borderColor = 'rgba(34, 197, 94, 0.5)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.borderColor = 'rgba(148, 163, 184, 0.2)';
            }}>
              <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🌐</div>
              <h2 style={{ color: '#f1f5f9', marginBottom: '0.5rem' }}>
                Ver Sitio Público
              </h2>
              <p style={{ color: '#94a3b8', margin: 0 }}>
                Ir al sitio web principal
              </p>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
